/**
 * Utility functions for quote filtering and sorting in admin dashboard.
 */

export function filterQuotes(quotes, statusFilter, searchTerm) {
  let result = [...quotes];

  if (statusFilter !== "all") {
    result = result.filter((q) => q.status === statusFilter);
  }

  if (searchTerm) {
    const term = searchTerm.toLowerCase();
    result = result.filter(
      (q) =>
        q.name?.toLowerCase().includes(term) ||
        q.email?.toLowerCase().includes(term) ||
        q.phone?.includes(term) ||
        q.selectedService?.toLowerCase().includes(term)
    );
  }

  return result;
}

export function sortQuotes(quotes, sortField, sortDir) {
  return [...quotes].sort((a, b) => {
    let aVal = a[sortField];
    let bVal = b[sortField];

    if (sortField === "created_at") {
      aVal = new Date(aVal);
      bVal = new Date(bVal);
    } else if (sortField === "estimatedPrice") {
      aVal = Number(aVal) || 0;
      bVal = Number(bVal) || 0;
    }

    if (sortDir === "asc") return aVal > bVal ? 1 : -1;
    return aVal < bVal ? 1 : -1;
  });
}

export function formatDate(dateStr) {
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export const STATUS_CONFIG = {
  pending: {
    label: "Pending",
    color: "bg-amber-100 text-amber-800 border-amber-200",
    dotColor: "bg-amber-500",
  },
  contacted: {
    label: "Contacted",
    color: "bg-sky-100 text-sky-800 border-sky-200",
    dotColor: "bg-sky-500",
  },
  booked: {
    label: "Booked",
    color: "bg-violet-100 text-violet-800 border-violet-200",
    dotColor: "bg-violet-500",
  },
  completed: {
    label: "Completed",
    color: "bg-green-100 text-green-800 border-green-200",
    dotColor: "bg-green-500",
  },
  cancelled: {
    label: "Cancelled",
    color: "bg-red-100 text-red-800 border-red-200",
    dotColor: "bg-red-500",
  },
};

export const PROPERTY_LABELS = {
  residential: "Residential Home",
  apartment: "Apartment/Flat",
  commercial: "Commercial/Office",
  airbnb: "Airbnb/Short-stay",
  "end-of-tenancy": "End of Tenancy",
};

export const PROPERTY_ICON_MAP = {
  commercial: "Building2",
  airbnb: "Briefcase",
};
